<template>
  <div class="wizard-step-indicator">
    <template v-for="(step, index) in numberedSteps">
      <div
        :class="{
          'wizard-step': true,
          active: index === currentStep,
          disabled: isAdd && index > currentStep,
          navigable: canNavigateTo(index),
        }"
        @click="canNavigateTo(index) ? changeStep(index) : null"
        :key="'step-' + index"
      >
        <div class="step-content">
          <feather-icon :icon="stepIcons[index]" size="25" />
          <div class="step-label text-capitalize">{{ step }}</div>
        </div>
      </div>
      <div v-if="index < numberedSteps.length - 1" class="arrow" :key="'arrow-' + index">
        <feather-icon icon="ChevronRightIcon" size="40" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: Number,
    numberedSteps: Array,
    stepIcons: Array,
    isAdd: Boolean,
    allowDirectStepNavigation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    canNavigateTo(index) {
      return this.allowDirectStepNavigation || index <= this.currentStep;
    },
    changeStep(index) {
      if (this.canNavigateTo(index)) {
        this.$emit("step-clicked", index);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wizard-step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  flex-wrap: wrap;
}

.wizard-step {
  display: flex;
  align-items: center;
  color: #838383;
  cursor: default;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: .5rem 0;
}

.step-label {
  margin-top: 5px;
}

.arrow {
  display: flex;
  align-items: center;
  padding-inline: 1rem;
}

.wizard-step.active .step-content {
  opacity: 1;
}

.disabled {
  color: #9c9c9c;
  cursor: default;
}

.navigable {
  cursor: pointer;
}

.active {
  color: #1b3d5e;
}

.dark-layout {
  .active {
    color: #fff !important;
  }
}
</style>
